import { render, staticRenderFns } from "./Inscricoes.vue?vue&type=template&id=93043f78&scoped=true&"
import script from "./Inscricoes.vue?vue&type=script&lang=js&"
export * from "./Inscricoes.vue?vue&type=script&lang=js&"
import style0 from "./Inscricoes.vue?vue&type=style&index=0&id=93043f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93043f78",
  null
  
)

export default component.exports